import {
    getSessionsFromGroup,
    initFirebase,
    listenToAnimationsGif,
} from "../domain/domain";
import {
    getUrlParameter
} from "../domain/utils";
import $ from "jquery"
import { GifReader, GifWriter } from "omggif";

interface AnimationState {
    initialX: number; initialY: number; targetX: number; targetY: number; progress: number; element: JQuery<HTMLElement>;
}

function newAnimation(image: string): AnimationState {
    let width = $(window).width()!;
    let height = $(window).height()!;

    let p = {
        initialX: Math.random()*(width/2) + width/4,
        initialY: Math.random()*(height/2) + height/4,
        targetX: Math.random()*(width),
        targetY: Math.random()*(height),
        progress: 0,
        element: null as unknown as JQuery<HTMLElement>
    };

    let elem = $(`<img style="image-rendering: pixelated; transition: all 9s; position: absolute; top: ${p.initialY}px; left: ${p.initialX}px; transform: scale(5);" src="${image}"></img>`);
    p.element = elem;

    elem.appendTo($(".constellation"));

    setTimeout(() => {
        elem.css("left", p.targetX + "px");
        elem.css("top", p.targetY + "px");
        elem.css("transform", 'scale(10)');
    }, 100)
    
    return p;
}


function dataURItoArray (dataURI: string) {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return ia;
}

function processImage(img: string): string {
    let buffer = dataURItoArray(img)
    let gr = new GifReader(<Buffer> <unknown> buffer);

    // Get the palette
    let frameInfo = gr.frameInfo(0);
    let paletteSize = frameInfo.palette_size!;
    let paletteOffset = frameInfo.palette_offset!;
    let palette = [];
    let colorToIndex : {[idx: number]: number}= {};

    for (let palette_index = 0; palette_index < paletteSize; palette_index++) {
        var r = buffer[paletteOffset + palette_index * 3];
        var g = buffer[paletteOffset + palette_index * 3 + 1];
        var b = buffer[paletteOffset + palette_index * 3 + 2];
        let color = (r * 256 + g) * 256 + b;
        palette.push(color);
        if (colorToIndex[color] === undefined) { colorToIndex[color] = palette_index; }
    }

    if (paletteSize == 2) { // Make the color always white when it's monocrome over transparent
        palette[1] = 0xeed202;
    }

    let frameCount = gr.numFrames();
    let width = gr.width;
    let height = gr.height;
    let scaleNumber = 1;

    var outbuf = <Buffer> <unknown> [];
    
    var gf = new GifWriter(outbuf, width * scaleNumber, height * scaleNumber, {
        palette: palette,
        loop: 0
    });
    
    for (let j = 0; j < frameCount; j++) {
        let idx = 0;
        let pixels = new Uint8Array(gr.width * gr.height * 4);
        let outpixels = new Uint8Array(width * height * scaleNumber * scaleNumber);
        gr.decodeAndBlitFrameRGBA(j, pixels);

        for(let y = 0; y < height; y++) {
            for (let lineRepeat = 0; lineRepeat < scaleNumber; lineRepeat++) {    
                for(let x = 0; x < height; x++) {
                    var r = pixels[(y * width + x) * 4];
                    var g = pixels[(y * width + x) * 4 + 1];
                    var b = pixels[(y * width + x) * 4 + 2];
                    let color = colorToIndex[(r * 256 + g) * 256 + b] || 0;
                    for (let colRepeat = 0; colRepeat < scaleNumber; colRepeat++) {
                        outpixels[idx] = color;
                        idx++;
                    }                                        
                }
            }
        }

        gf.addFrame(0, 0, width * scaleNumber, height * scaleNumber,
            <number[]> <unknown> outpixels, {
                delay: 20,
                transparent: 0, //(palette.length == 2) ? 0 : undefined,
                disposal: 2
            });
    }
    
    outbuf = outbuf.slice(0, gf.end());
    let buf_str = String.fromCharCode(...outbuf);
    buf_str = "data:image/gif;base64," + btoa(buf_str);

    return buf_str;
}

function shuffle<T>(array: Array<T>): Array<T> {
    let currentIndex = array.length,randomIndex;

    while (currentIndex != 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
  
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
  
    return array;
}

export function constellationSimple() {
    initFirebase();

    var sessionId = getUrlParameter("session");
    var sessionGroupId = getUrlParameter("session_group");
    var isSessionGroupViewer = !!sessionGroupId;
    var sessions_in_group : Array<any>= [];
    var session_index : number = 0;
    let animations : Array<string>  = [];

    let state = {
        nextImage: 0,
        animations: [] as Array<AnimationState>,
        timeOfPreviousAnimation: Date.now(),
    };

    if (isSessionGroupViewer) {
        var group_label = $("<div></div>").css({
            "color": "white",
            "background": "rgba(20,20,200,0.2)",
            "font-size": "50px",
            "width": "100%",
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "margin": "auto",
            "text-align": "center",
            "bottom":0,
            "position": "absolute"
        });

        group_label.appendTo($("body"));

        document.addEventListener("keydown", function onPress(event) {
            switch (event.key) {
                case "ArrowLeft":
                    session_index -= 1;
                    if (session_index < 0) {
                        session_index = sessions_in_group.length - 1;
                    }        
                    break;
                case "ArrowRight":
                    session_index += 1;
                    if (session_index >= sessions_in_group.length) {
                        session_index = 0;
                    }        
                    break;
                default:
                    return;
            }

            clearAnimations();
            refreshGroup();
        });

        function refreshGroup() {
            animations = sessions_in_group[session_index].images;
            animations = shuffle(animations);
            group_label.text(sessions_in_group[session_index].session_name);
        }

        function clearAnimations() {
            for (let animation of state.animations) {
                animation.element.remove();
            }
            state.animations = [];
        }
        

        getSessionsFromGroup(sessionGroupId!).then(r => {
            for (let session_id in r.sessions) {                
                ((session_id)=>{
                    let obj = {
                        session_name: r.sessions[session_id].session_name,
                        images: [] as Array<any>
                    };
                    listenToAnimationsGif(session_id!, (data) => {
                        obj.images = Object.entries(data)
                            .map(anim => processImage(anim[1]))
                        refreshGroup();                        
                    }, (error) => {
                        //alert("Error loading images: " + error);
                    });
                
                    sessions_in_group.push(obj)
                })(session_id)                                
            }
            console.log(sessions_in_group);
        });

    } else {
        listenToAnimationsGif(sessionId!, (data) => {
            animations = Object.entries(data)
                .map(anim => processImage(anim[1]))
            animations = shuffle(animations);
        }, (error) => {
            alert("Error loading images: " + error);
        });    
    }
    
    let fps = 15;
    let fpsInterval = 1000 / fps;
    let prevFrame = Date.now() - 10000;
    let now = prevFrame;

    function animationStep() {
        let maxAnimations = 30;

        if (animations.length == 0) {
		    window.requestAnimationFrame(animationStep);
		    return;
	    }

        now = Date.now();
        let elapsed = now - prevFrame;
    
        if (elapsed > fpsInterval) {
            prevFrame = now - (elapsed % fpsInterval);      

            if (state.animations.length > 0 && state.animations[0].progress >= 1) {
                state.animations[0].element.remove();
                state.animations.shift();
            }

            if (state.animations.length < maxAnimations && (now - state.timeOfPreviousAnimation) > 500) {
                if (state.nextImage == 0) {
                    animations = shuffle(animations);
                }
                state.timeOfPreviousAnimation = now;
                state.animations.push(newAnimation(animations[state.nextImage]));
                state.nextImage = (state.nextImage + 1) % animations.length;
            }

            for (let animation of state.animations) {
                animation.progress += elapsed/10000;
            }
        }

	window.requestAnimationFrame(animationStep);
    }
    window.requestAnimationFrame(animationStep);
}
